import React from 'react';
import { HiOutlinePlus, HiOutlineViewList } from 'react-icons/hi';

/**
 * Slim top bar over the transcript: sidebar toggle, conversation title, and a
 * new-chat action mirroring the sidebar's (kept here because the sidebar is
 * hidden on mobile and while collapsed).
 */
export default function ChatHeader({ title, onToggleSidebar, sidebarOpen, onNewChat }) {
  return (
    <header className="flex h-12 flex-none items-center gap-2 px-3">
      {!sidebarOpen && (
        <button
          type="button"
          onClick={onToggleSidebar}
          aria-label="Open sidebar"
          className="rounded p-1.5 text-ink-faint transition-colors hover:bg-surface hover:text-ink"
        >
          <HiOutlineViewList size={16} />
        </button>
      )}

      <h1 className="min-w-0 flex-1 truncate text-[14px] text-ink-muted">{title}</h1>

      <button
        type="button"
        onClick={onNewChat}
        title="New chat"
        aria-label="New chat"
        className="rounded p-1.5 text-ink-faint transition-colors hover:bg-surface hover:text-ink"
      >
        <HiOutlinePlus size={16} />
      </button>
    </header>
  );
}
